export default "__VITE_ASSET__CkIST_HR__"